module.exports = __webpack_public_path__ + "img/pistal.38992d51.png";